export const LOAD_REQUESTED = "PRIMARY_ACTION_FIELD_TEMPLATE/LOAD_REQUESTED";
export const LOAD_SUCCESS = "PRIMARY_ACTION_FIELD_TEMPLATE/LOAD_SUCCESS";
export const LOAD_FAIL = "PRIMARY_ACTION_FIELD_TEMPLATE/LOAD_FAIL";

export default (state = {}, { type, data }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadPrimaryActionFieldTemplate = data => ({ type: LOAD_REQUESTED, data });
export const successLoadPrimaryActionFieldTemplate = data => ({ type: LOAD_SUCCESS, data });
export const failLoadPrimaryActionFieldTemplate = data => ({ type: LOAD_FAIL, data });
